<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="推广计划 id" prop="campaignId">
          <el-input v-model="dataForm.campaignId" placeholder="推广计划 id"></el-input>
      </el-form-item>
          <el-form-item label="广告组 id" prop="adgroupId">
          <el-input v-model="dataForm.adgroupId" placeholder="广告组 id"></el-input>
      </el-form-item>
          <el-form-item label="广告组名称" prop="adgroupName">
          <el-input v-model="dataForm.adgroupName" placeholder="广告组名称"></el-input>
      </el-form-item>
          <el-form-item label="投放版位集和" prop="siteSet">
          <el-input v-model="dataForm.siteSet" placeholder=" SITE_SET_TENCENT_NEWS+SITE_SET_TENCENT_VIDEO+SITE_SET_MOBILE_UNION+SITE_SET_KANDIAN+SITE_SET_QQ_MUSIC_GAME 的组合"></el-input>
      </el-form-item>
          <el-form-item label="是否开启自动版位功能" prop="automaticSiteEnabled">
          <el-input v-model="dataForm.automaticSiteEnabled" placeholder="是否开启自动版位功能（暂不包含 SITE_SET_WECHAT 和 SITE_SET_MOMENTS），此字段与 site_set 字段至少需要写入一个。"></el-input>
      </el-form-item>
          <el-form-item label="广告优化目标类型" prop="optimizationGoal">
          <el-input v-model="dataForm.optimizationGoal" placeholder="广告优化目标类型"></el-input>
      </el-form-item>
          <el-form-item label="计费类型" prop="billingEvent">
          <el-input v-model="dataForm.billingEvent" placeholder="计费类型"></el-input>
      </el-form-item>
          <el-form-item label="广告出价，单位为分，出价限制" prop="bidAmount">
          <el-input v-model="dataForm.bidAmount" placeholder="广告出价，单位为分，出价限制：
CPC 出价限制：介于 10 分-10,000 分之间（0.1 元-100 元，单位为人民币）
CPM 出价限制：介于 150 分-99,900 分之间（1.5 元-999 元，单位为人民币，当 SITE_SET 仅为 SITE_SET_PCQQ 时，介于 50 分-99,900 分之间）
CPA 出价限制：介于 100 分-50,000 分之间（1 元-500 元，单位为人民币）
oCPC/oCPM 出价限制：介于 1 分-500,000 分之间（0.01 元-5000 元，单位为人民币）"></el-input>
      </el-form-item>
          <el-form-item label="总预算，单位为分" prop="totalBudget">
          <el-input v-model="dataForm.totalBudget" placeholder="总预算，单位为分，仅合约 CPM 广告有效，其他广告无效"></el-input>
      </el-form-item>
          <el-form-item label="广告组日预算，单位为分，设置为 0 表示不设预算（即不限）" prop="dailyBudget">
          <el-input v-model="dataForm.dailyBudget" placeholder="广告组日预算，单位为分，设置为 0 表示不设预算（即不限）"></el-input>
      </el-form-item>
          <el-form-item label="推广目标类型" prop="promotedObjectType">
          <el-input v-model="dataForm.promotedObjectType" placeholder="推广目标类型"></el-input>
      </el-form-item>
          <el-form-item label="推广目标 id，详见" prop="promotedObjectId">
          <el-input v-model="dataForm.promotedObjectId" placeholder="推广目标 id，详见"></el-input>
      </el-form-item>
          <el-form-item label="安卓应用渠道包" prop="appAndroidChannelPackageId">
          <el-input v-model="dataForm.appAndroidChannelPackageId" placeholder="安卓应用渠道包 id，在投放推广目标类型为 Android 应用的情况下，可以填写腾讯开放平台安卓应用和腾讯广告渠道包的渠道包 id。渠道包 id 可以从推广目标模块的读取接口获取，渠道包 id 字段由"xx;yy" 两部分组成，在写入时 xx 会被置为 0，0 为正常。"></el-input>
      </el-form-item>
          <el-form-item label="微信小游戏 id" prop="miniGameProgramId">
          <el-input v-model="dataForm.miniGameProgramId" placeholder="微信小游戏 id"></el-input>
      </el-form-item>
          <el-form-item label="定向 id，仅非朋友圈广告有效" prop="targetingId">
          <el-input v-model="dataForm.targetingId" placeholder="定向 id，仅非朋友圈广告有效"></el-input>
      </el-form-item>
          <el-form-item label="定向详细设置，存放所有定向条件" prop="targeting">
          <el-input v-model="dataForm.targeting" placeholder="定向详细设置，存放所有定向条件"></el-input>
      </el-form-item>
          <el-form-item label="已选择定向条件的描述" prop="targetingTranslation">
          <el-input v-model="dataForm.targetingTranslation" placeholder="已选择定向条件的描述"></el-input>
      </el-form-item>
          <el-form-item label="是否包含不支持定向" prop="isIncludeUnsupportedTargeting">
          <el-input v-model="dataForm.isIncludeUnsupportedTargeting" placeholder="是否包含不支持定向，true：包含 API 暂不支持读写的定向信息，false：不包含 API 暂不支持读写的定向信息"></el-input>
      </el-form-item>
          <el-form-item label="场景定向" prop="sceneSpec">
          <el-input v-model="dataForm.sceneSpec" placeholder="场景定向"></el-input>
      </el-form-item>
          <el-form-item label="是否使用智能场景匹配或优量汇媒体类型场景定向" prop="flowOptimizationEnabled">
          <el-input v-model="dataForm.flowOptimizationEnabled" placeholder="	是否使用智能场景匹配，仅支持优量汇版位使用，且不能和优量汇行业精选流量包(mobile_union_industry)或优量汇媒体类型场景定向（mobile_union_category）同时使用，flow_optimization_enabled 设置为 true, 开启智能场景匹配"></el-input>
      </el-form-item>
          <el-form-item label="开始投放日期" prop="beginDate">
          <el-input v-model="dataForm.beginDate" placeholder="开始投放日期，日期格式：YYYY-MM-DD，且日期小于等于 end_date"></el-input>
      </el-form-item>
          <el-form-item label="首日开始投放时间" prop="firstDayBeginTime">
          <el-input v-model="dataForm.firstDayBeginTime" placeholder="首日开始投放时间，首日开始投放时间：HH:ii:ss"></el-input>
      </el-form-item>
          <el-form-item label="	结束投放日期" prop="endDate">
          <el-input v-model="dataForm.endDate" placeholder="	结束投放日期，日期格式：YYYY-MM-DD，大于等于今天，且大于等于 begin_date ；如果希望长期投放，传空字符串；针对微信流量的更新 end_time 的场景，会有额外的规则（更新后的 end_time 至少是当前时间的 6h 之后 且 当前更新时间到 end_time 与 投放时段 有交集）"></el-input>
      </el-form-item>
          <el-form-item label="投放时间段" prop="timeSeries">
          <el-input v-model="dataForm.timeSeries" placeholder="投放时间段，格式为 48 * 7 位字符串，且都为 0 和 1，以半个小时为最小粒度，从周一零点开始至周日 24 点结束。0 为不投放，1 为投放，全传 1 视为全时段投放，不允许全部传 0。"></el-input>
      </el-form-item>
          <el-form-item label="客户设置的状态" prop="configuredStatus">
          <el-input v-model="dataForm.configuredStatus" placeholder="客户设置的状态，默认值：该字段默认值 AD_STATUS_NORMAL"></el-input>
      </el-form-item>
          <el-form-item label="自定义分类" prop="customizedCategory">
          <el-input v-model="dataForm.customizedCategory" placeholder="自定义分类，关键词用半角逗号','分隔，如：本地生活,餐饮"></el-input>
      </el-form-item>
          <el-form-item label="创建时间（时间戳）" prop="createdTime">
          <el-input v-model="dataForm.createdTime" placeholder="创建时间（时间戳）"></el-input>
      </el-form-item>
          <el-form-item label="最后修改时间（时间戳）" prop="lastModifiedTime">
          <el-input v-model="dataForm.lastModifiedTime" placeholder="最后修改时间（时间戳）"></el-input>
      </el-form-item>
          <el-form-item label="广告数量" prop="adCount">
          <el-input v-model="dataForm.adCount" placeholder="广告数量，创意数量查询，（非动态创意）查询当前广告未删除的创意数量，单创意指广告下只有 1 条创意，多创意指大于 1 条创意。"></el-input>
      </el-form-item>
          <el-form-item label="动态商品广告属性" prop="dynamicAdSpec">
          <el-input v-model="dataForm.dynamicAdSpec" placeholder="动态商品广告属性，当广告形态为动态商品广告时，该字段必填。为了不同投放端体验的一致性，在创建广告时如广告创意 dynamic_adcreative_spec 字段不为空且对应广告组缺失 dynamic_ad_spec 或 product_source 内容，系统会自动将广告创意中 dynamic_ad_spec 或 product_source 内容写入对应广告组。"></el-input>
      </el-form-item>
          <el-form-item label="用户行为数据源。" prop="userActionSets">
          <el-input v-model="dataForm.userActionSets" placeholder="用户行为数据源，详见 [转化归因功能]，当 promoted_object_type 为 PROMOTED_OBJECT_TYPE_LEAD_AD、PROMOTED_OBJECT_TYPE_ECOMMERCE、PROMOTED_OBJECT_TYPE_LINK 时，允许传入 WEB + iOS + Android 数据源；当 promoted_object_type 为 PROMOTED_OBJECT_TYPE_APP_ANDROID 时，至少选择一个安卓数据源，可同时使用 web 数据源；当 promoted_object_type 为 PROMOTED_OBJECT_TYPE_APP_IOS 时，至少选择一个 ios 数据源，可同时使用 web 数据源。"></el-input>
      </el-form-item>
          <el-form-item label="补充的 app 用户行为数据源" prop="additionalUserActionSets">
          <el-input v-model="dataForm.additionalUserActionSets" placeholder="补充的 app 用户行为数据源，字段待废弃。
当 promoted_object_type 为 PROMOTED_OBJECT_TYPE_ECOMMERCE、PROMOTED_OBJECT_TYPE_LINK、PROMOTED_OBJECT_TYPE_QQ_BROWSER_MINI_PROGRAM，且行业为网服、电商、金融的广告主，可填写补充的 app 用户行为数据源。数据源需为安卓/ios 数据源，且需确保为同一个 app 的数据源。"></el-input>
      </el-form-item>
          <el-form-item label="是否已删除，true：是，false：否" prop="isDeleted">
          <el-input v-model="dataForm.isDeleted" placeholder="是否已删除，true：是，false：否"></el-input>
      </el-form-item>
          <el-form-item label="DC 动态创意 id" prop="dynamicCreativeId">
          <el-input v-model="dataForm.dynamicCreativeId" placeholder="DC 动态创意 id"></el-input>
      </el-form-item>
          <el-form-item label="是否是激励视频广告（字段已经废弃，忽略）" prop="isRewardedVideoAd">
          <el-input v-model="dataForm.isRewardedVideoAd" placeholder="是否是激励视频广告（字段已经废弃，忽略）"></el-input>
      </el-form-item>
          <el-form-item label="成本保障状态信息说明，不超过 1024 个字符" prop="costGuaranteeMessage">
          <el-input v-model="dataForm.costGuaranteeMessage" placeholder="成本保障状态信息说明，不超过 1024 个字符"></el-input>
      </el-form-item>
          <el-form-item label="成本保障状态，成本保障状态定义" prop="costGuaranteeStatus">
          <el-input v-model="dataForm.costGuaranteeStatus" placeholder="成本保障状态，成本保障状态定义"></el-input>
      </el-form-item>
          <el-form-item label="	出价策略，仅 oCPC/oCPM 广告可设置，枚举列表" prop="bidStrategy">
          <el-input v-model="dataForm.bidStrategy" placeholder="	出价策略，仅 oCPC/oCPM 广告可设置，枚举列表"></el-input>
      </el-form-item>
          <el-form-item label="	扩量种子人群（" prop="coldStartAudience">
          <el-input v-model="dataForm.coldStartAudience" placeholder="	扩量种子人群（原冷启动人群名称升级扩量种子人群）
1、系统会学习您选择的人群包数据，帮助提升广告投放效果；
2、当且仅当广告为 oCPC/oCPM 开启自动扩量的广告、且投放的流量不是应用宝时；
3、仅支持人群类型为 CUSTOMER_FILE（号码文件人群）的可用人群 id、且人群数量大于 100 时；"></el-input>
      </el-form-item>
          <el-form-item label="是否使用系统优选" prop="autoAudience">
          <el-input v-model="dataForm.autoAudience" placeholder="是否使用系统优选，"></el-input>
      </el-form-item>
          <el-form-item label="是否使用自动扩量" prop="expandEnabled">
          <el-input v-model="dataForm.expandEnabled" placeholder="是否使用自动扩量，当广告为 oCPC/oCPM、CPC 出价时，可将 expand_enabled 设置为 true，微信广告当且仅当出价为 oCPC/oCPM 时，才可将 expand_enabled 设置为 true。2022 年 6 月 30 日起，自动扩量无法与行为兴趣意向、“二方人群”人群包同时使用，expand_enabled 设置为 true, 开启自动扩量"></el-input>
      </el-form-item>
          <el-form-item label="	扩量不可突破定向" prop="expandTargeting">
          <el-input v-model="dataForm.expandTargeting" placeholder="	扩量不可突破定向"></el-input>
      </el-form-item>
          <el-form-item label="oCPC/oCPM 深度优化内容，oCPC/oCPM 深度优化内容，创建时若此字段不传，或传空则视为无限制条件；
深度优化不可取消，也不支持在编辑环节从未使用深度优化切换为使用深度优化。" prop="deepConversionSpec">
          <el-input v-model="dataForm.deepConversionSpec" placeholder="oCPC/oCPM 深度优化内容，oCPC/oCPM 深度优化内容，创建时若此字段不传，或传空则视为无限制条件；
深度优化不可取消，也不支持在编辑环节从未使用深度优化切换为使用深度优化。"></el-input>
      </el-form-item>
          <el-form-item label="oCPC/oCPM 深度优化方式配置 当深度优化类型=优化深度转化行为时，此前支持选择“优化方式”；目前深度优化能力升级，两阶段/双目标优化方式已进行合并，因此优化方式字段即将下线，可以不再输入。如调用该字段，系统会默认按两阶段优化方式进行创建，" prop="deepOptimizationActionType">
          <el-input v-model="dataForm.deepOptimizationActionType" placeholder="oCPC/oCPM 深度优化方式配置 当深度优化类型=优化深度转化行为时，此前支持选择“优化方式”；目前深度优化能力升级，两阶段/双目标优化方式已进行合并，因此优化方式字段即将下线，可以不再输入。如调用该字段，系统会默认按两阶段优化方式进行创建，"></el-input>
      </el-form-item>
          <el-form-item label="门店 id 列表," prop="poiList">
          <el-input v-model="dataForm.poiList" placeholder="门店 id 列表,
1. 推广目标类型 PROMOTED_OBJECT_TYPE_LOCAL_ADS_WECHAT，非朋友圈版位，使用 promoted_object_id 来表示门店 id，不能清空；
2. 推广目标类型 PROMOTED_OBJECT_TYPE_LOCAL_ADS_WECHAT，朋友圈版位，使用 poi_list 来表示门店 id，不能清空；
3. 其他推广目标下，使用 poi_list 来表示门店信息，可以清空；，最多可输入 100 个门店"></el-input>
      </el-form-item>
          <el-form-item label="转化 id，包含优化目标" prop="conversionId">
          <el-input v-model="dataForm.conversionId" placeholder="转化 id，包含优化目标，深度优化目标，数据上报方式，归因方式等信息，仅 ocpc/ocpm 广告可设置，转化 id 设置后不可修改。可通过辅助工具[转化查询接口]查询可使用的转化 id。当传入转化 id 时，可无需再传入 user_action_sets，additional_user_action_sets，optimization_goal，deep_conversion_spec 字段信息。如若同时传入转化 id 和 user_action_sets/additional_user_action_sets，将以转化 id 的信息为第一优先级；如若同时传入转化 id 和 optimization_goal/deep_conversion_spec，仅当转化 id 中包含的优化目标/深度优化目标与传入的优化目标/深度优化目标信息一致时，才允许创建，否则将不允许创建。功能灰度开放中。"></el-input>
      </el-form-item>
          <el-form-item label="深度优化行为的出价，使用转化 id 确认优化目标和深度优化目标的广告主，深度优化行为的目标出价无需传 deep_conversion_spec 结构体中字段，可直接使用 deep_conversion_behavior_bid 字段传输深度出价，当深度转化行为目标为次留率时，单位为%，最小值 1，最大值 99。如输入 40，代表次留率目标 40%，单位为分。" prop="deepConversionBehaviorBid">
          <el-input v-model="dataForm.deepConversionBehaviorBid" placeholder="深度优化行为的出价，使用转化 id 确认优化目标和深度优化目标的广告主，深度优化行为的目标出价无需传 deep_conversion_spec 结构体中字段，可直接使用 deep_conversion_behavior_bid 字段传输深度出价，当深度转化行为目标为次留率时，单位为%，最小值 1，最大值 99。如输入 40，代表次留率目标 40%，单位为分。"></el-input>
      </el-form-item>
          <el-form-item label="	深度优化价值的期望 ROI，使用转化 id 确认优化目标和深度优化目标的广告主，深度优化价值的目标出价无需传 deep_conversion_spec 结构体中字段，可直接使用 deep_conversion_worth_rate 字段传输深度出价。深度 roi 自动出价的场景下不能使用此字段，该功能灰度开放中。" prop="deepConversionWorthRate">
          <el-input v-model="dataForm.deepConversionWorthRate" placeholder="	深度优化价值的期望 ROI，使用转化 id 确认优化目标和深度优化目标的广告主，深度优化价值的目标出价无需传 deep_conversion_spec 结构体中字段，可直接使用 deep_conversion_worth_rate 字段传输深度出价。深度 roi 自动出价的场景下不能使用此字段，该功能灰度开放中。"></el-input>
      </el-form-item>
          <el-form-item label="	强化优化价值的期望 ROI，使用转化 id 确认优化目标和强化优化目标的广告主，强化优化价值的目标出价无需传 deep_conversion_spec 结构体中字段，可直接使用 deep_conversion_worth_advanced_rate 字段传输深度出价。该功能灰度开放中。" prop="deepConversionWorthAdvancedRate">
          <el-input v-model="dataForm.deepConversionWorthAdvancedRate" placeholder="	强化优化价值的期望 ROI，使用转化 id 确认优化目标和强化优化目标的广告主，强化优化价值的目标出价无需传 deep_conversion_spec 结构体中字段，可直接使用 deep_conversion_worth_advanced_rate 字段传输深度出价。该功能灰度开放中。"></el-input>
      </el-form-item>
          <el-form-item label="	加强优化行为的出价，使用转化 id 确认优化目标和加强优化目标的广告主，加强优化行为的目标出价无需传 deep_conversion_spec 结构体中字段，可直接使用 deep_conversion_behavior_advanced_bid 字段传输深度出价，当加强转化行为目标为次留率时，单位为%，最小值 1，最大值 99。如输入 40，代表次留率目标 40%，单位为分。" prop="deepConversionBehaviorAdvancedBid">
          <el-input v-model="dataForm.deepConversionBehaviorAdvancedBid" placeholder="	加强优化行为的出价，使用转化 id 确认优化目标和加强优化目标的广告主，加强优化行为的目标出价无需传 deep_conversion_spec 结构体中字段，可直接使用 deep_conversion_behavior_advanced_bid 字段传输深度出价，当加强转化行为目标为次留率时，单位为%，最小值 1，最大值 99。如输入 40，代表次留率目标 40%，单位为分。"></el-input>
      </el-form-item>
          <el-form-item label="广告包渠道包审核消息" prop="androidChannelPackageAuditMessage">
          <el-input v-model="dataForm.androidChannelPackageAuditMessage" placeholder="广告包渠道包审核消息"></el-input>
      </el-form-item>
          <el-form-item label="广告组在系统中的状态" prop="systemStatus">
          <el-input v-model="dataForm.systemStatus" placeholder="广告组在系统中的状态"></el-input>
      </el-form-item>
          <el-form-item label="出价方式" prop="bidMode">
          <el-input v-model="dataForm.bidMode" placeholder="出价方式，
1. bid_mode 为 billing_event 升级字段，不可同时输入，升级后直接写入 bid_mode 字段即可；
2. 当投放智能出价广告，可写入 BID_MODE_OCPC/BID_MODE_OCPM。此时，optimization_goal 优化目标字段必填；
3. 当投放非智能出价广告，可写入 BID_MODE_CPC/BID_MODE_CPM/BID_MODE_CPA。此时，optimization_goal 优化目标字段不可填；
4. 针对非微信流量，BID_MODE_CPC 可编辑修改为 BID_MODE_OCPC，BID_MODE_CPM 可编辑修改为 BID_MODE_OCPM，其他修改不可操作。针对微信流量，bid_mode 字段不可修改；
5. 可通过 adcreative_templates/get 接口查询不同情况下支持的出价方式;，"></el-input>
      </el-form-item>
          <el-form-item label="广告状态" prop="status">
          <el-input v-model="dataForm.status" placeholder="广告状态"></el-input>
      </el-form-item>
          <el-form-item label="出价系数设置内容，仅当投放 oCPC、oCPM 广告时可使用，编辑广告时，分版位功能仅支持出价系数的变更，分城市出价支持城市包和出价系数的变更。" prop="bidAdjustment">
          <el-input v-model="dataForm.bidAdjustment" placeholder="出价系数设置内容，仅当投放 oCPC、oCPM 广告时可使用，编辑广告时，分版位功能仅支持出价系数的变更，分城市出价支持城市包和出价系数的变更。"></el-input>
      </el-form-item>
          <el-form-item label="是否开启一键起量" prop="autoAcquisitionEnabled">
          <el-input v-model="dataForm.autoAcquisitionEnabled" placeholder="是否开启一键起量,
1. 一键起量会在 6 小时内尽量消耗完预算，期间产生的消耗不赔付，但转化计入赔付门槛判断；
2. 一条广告可使用多次一键起量功能，多次开启功能仅针对 2022 年 3 月 10 日起新建的广告有效，探索中任何原因导致广告暂停播放，都会导致起量中止；
3. 一键起量支持微信/非微信通投；
4. 一键起量仅支持 oCPX 广告使用，但不支持与自动出价同时使用。"></el-input>
      </el-form-item>
          <el-form-item label="一键起量探索预算，单位为分" prop="autoAcquisitionBudget">
          <el-input v-model="dataForm.autoAcquisitionBudget" placeholder="一键起量探索预算，单位为分，一键起量预算设置后不可修改"></el-input>
      </el-form-item>
          <el-form-item label="创意展示类型，不填该字段默认优选模式，" prop="creativeDisplayType">
          <el-input v-model="dataForm.creativeDisplayType" placeholder="创意展示类型，不填该字段默认优选模式，"></el-input>
      </el-form-item>
          <el-form-item label="	是否开启自动衍生视频创意" prop="autoDerivedCreativeEnabled">
          <el-input v-model="dataForm.autoDerivedCreativeEnabled" placeholder="	是否开启自动衍生视频创意。
开启后，根据广告主的投放数据以及上传的素材, 通过策略选择效果最佳的视频模板、音乐, 并复制已有创意元素, 程序化生成视频创意。"></el-input>
      </el-form-item>
          <el-form-item label="出价类型，当出价类型为 SMART_BID_TYPE_SYSTEMATIC 时，不可传入 bid_amount，暂不支持微信流量，功能灰度开放中。smart_bid_type 出价类型仅支持 oCPX 广告使用，[枚举详情]
默认值：SMART_BID_TYPE_CUSTOM" prop="smartBidType">
          <el-input v-model="dataForm.smartBidType" placeholder="出价类型，当出价类型为 SMART_BID_TYPE_SYSTEMATIC 时，不可传入 bid_amount，暂不支持微信流量，功能灰度开放中。smart_bid_type 出价类型仅支持 oCPX 广告使用，[枚举详情]
默认值：SMART_BID_TYPE_CUSTOM"></el-input>
      </el-form-item>
          <el-form-item label="自动出价下 单位为分" prop="smartCostCap">
          <el-input v-model="dataForm.smartCostCap" placeholder="自动出价下，系统计算的预计成本的上限值，单位为分"></el-input>
      </el-form-item>
          <el-form-item label="营销目标" prop="marketingScene">
          <el-input v-model="dataForm.marketingScene" placeholder="营销目标"></el-input>
      </el-form-item>
          <el-form-item label="广告标签：广告主可传输多个字符串用于对广告进行标注。标注内容对广告投放无影响，仅用于广告管理。" prop="customAdgroupTag">
          <el-input v-model="dataForm.customAdgroupTag" placeholder="广告标签：广告主可传输多个字符串用于对广告进行标注。标注内容对广告投放无影响，仅用于广告管理。"></el-input>
      </el-form-item>
          <el-form-item label="智能定向功能,功能灰度开放" prop="smartTargeting">
          <el-input v-model="dataForm.smartTargeting" placeholder="智能定向功能,功能灰度开放，如需使用可联系您的运营接口同学。
智能定向功能与自动扩量/系统优选相关字段不可同时设置。2022 年 6 月 30 日起，智能定向无法与行为兴趣意向、“二方人群”人群包同时使用"></el-input>
      </el-form-item>
          <el-form-item label="DC 动态创意 id 集合" prop="dynamicCreativeIdSet">
          <el-input v-model="dataForm.dynamicCreativeIdSet" placeholder="DC 动态创意 id 集合"></el-input>
      </el-form-item>
          <el-form-item label="广告系统状态详情内容" prop="systemStatusExplanation">
          <el-input v-model="dataForm.systemStatusExplanation" placeholder="广告系统状态详情内容"></el-input>
      </el-form-item>
          <el-form-item label="是否开启自动衍生落地页开关" prop="autoDerivedLandingPageSwitch">
          <el-input v-model="dataForm.autoDerivedLandingPageSwitch" placeholder="是否开启自动衍生落地页开关"></el-input>
      </el-form-item>
          <el-form-item label="搜索定向拓展开关" prop="searchExpandTargetingSwitch">
          <el-input v-model="dataForm.searchExpandTargetingSwitch" placeholder="搜索定向拓展开关"></el-input>
      </el-form-item>
          <el-form-item label="	一键起量状态" prop="autoAcquisitionStatus">
          <el-input v-model="dataForm.autoAcquisitionStatus" placeholder="	一键起量状态,
一键起量状态表示当前广告在开启一键起量时，所处的不同起量阶段。一键起量状态与一键起量开关是两个独立的字段，一键起量开关为客户创建或更新时设置的开关，正常的广告在一键起量过程结束后，一键起量开关不会随一键起量状态改变。起量结束后，如果想再次开启一键起量，需要关闭一键起量开关后再次开启一键起量开关，一键起量状态定义"></el-input>
      </el-form-item>
          <el-form-item label="出价场景，" prop="bidScene">
          <el-input v-model="dataForm.bidScene" placeholder="出价场景，游戏行业投放端又称投放场景，该能力与出价类型(smart_bid_type)/出价策略(bid_strategy)互斥使用用，"></el-input>
      </el-form-item>
          </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        campaignId: '',
        adgroupId: '',
        adgroupName: '',
        siteSet: '',
        automaticSiteEnabled: '',
        optimizationGoal: '',
        billingEvent: '',
        bidAmount: '',
        totalBudget: '',
        dailyBudget: '',
        promotedObjectType: '',
        promotedObjectId: '',
        appAndroidChannelPackageId: '',
        miniGameProgramId: '',
        targetingId: '',
        targeting: '',
        targetingTranslation: '',
        isIncludeUnsupportedTargeting: '',
        sceneSpec: '',
        flowOptimizationEnabled: '',
        beginDate: '',
        firstDayBeginTime: '',
        endDate: '',
        timeSeries: '',
        configuredStatus: '',
        customizedCategory: '',
        createdTime: '',
        lastModifiedTime: '',
        adCount: '',
        dynamicAdSpec: '',
        userActionSets: '',
        additionalUserActionSets: '',
        isDeleted: '',
        dynamicCreativeId: '',
        isRewardedVideoAd: '',
        costGuaranteeMessage: '',
        costGuaranteeStatus: '',
        bidStrategy: '',
        coldStartAudience: '',
        autoAudience: '',
        expandEnabled: '',
        expandTargeting: '',
        deepConversionSpec: '',
        deepOptimizationActionType: '',
        poiList: '',
        conversionId: '',
        deepConversionBehaviorBid: '',
        deepConversionWorthRate: '',
        deepConversionWorthAdvancedRate: '',
        deepConversionBehaviorAdvancedBid: '',
        androidChannelPackageAuditMessage: '',
        systemStatus: '',
        bidMode: '',
        status: '',
        bidAdjustment: '',
        autoAcquisitionEnabled: '',
        autoAcquisitionBudget: '',
        creativeDisplayType: '',
        autoDerivedCreativeEnabled: '',
        smartBidType: '',
        smartCostCap: '',
        marketingScene: '',
        customAdgroupTag: '',
        smartTargeting: '',
        dynamicCreativeIdSet: '',
        systemStatusExplanation: '',
        autoDerivedLandingPageSwitch: '',
        searchExpandTargetingSwitch: '',
        autoAcquisitionStatus: '',
        bidScene: '',
        createDate: '',
        creator: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        campaignId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        adgroupId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        adgroupName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        siteSet: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        automaticSiteEnabled: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        optimizationGoal: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        billingEvent: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bidAmount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        totalBudget: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        dailyBudget: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        promotedObjectType: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        promotedObjectId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        appAndroidChannelPackageId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        miniGameProgramId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        targetingId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        targeting: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        targetingTranslation: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        isIncludeUnsupportedTargeting: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        sceneSpec: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        flowOptimizationEnabled: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        beginDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        firstDayBeginTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        endDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        timeSeries: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        configuredStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        customizedCategory: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createdTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        lastModifiedTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        adCount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        dynamicAdSpec: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        userActionSets: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        additionalUserActionSets: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        isDeleted: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        dynamicCreativeId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        isRewardedVideoAd: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        costGuaranteeMessage: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        costGuaranteeStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bidStrategy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        coldStartAudience: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        autoAudience: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        expandEnabled: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        expandTargeting: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deepConversionSpec: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deepOptimizationActionType: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        poiList: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        conversionId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deepConversionBehaviorBid: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deepConversionWorthRate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deepConversionWorthAdvancedRate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deepConversionBehaviorAdvancedBid: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        androidChannelPackageAuditMessage: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        systemStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bidMode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bidAdjustment: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        autoAcquisitionEnabled: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        autoAcquisitionBudget: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        creativeDisplayType: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        autoDerivedCreativeEnabled: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        smartBidType: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        smartCostCap: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        marketingScene: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        customAdgroupTag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        smartTargeting: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        dynamicCreativeIdSet: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        systemStatusExplanation: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        autoDerivedLandingPageSwitch: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        searchExpandTargetingSwitch: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        autoAcquisitionStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bidScene: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/tencentadgroups/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/tencentadgroups/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
